export const registryId = 'Global';
export default registryId;
